module.exports = __webpack_public_path__ + "static/media/S.d7b0419a.jpg";